import React, { Component } from 'react';
import $, { event } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { tokenVerification } from "./Utils";

class RiskRuleForAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectedRuleType: "1",
            admissionId: localStorage.getItem("patientAdmissionId"),
            journals: [],
            medications: [],
            loadingJournals: false,
            riskFactors: [],
            selectedRiskFactorId: "",
            loadingRiskFactors: false,
            selectedComparison: "",
            thresholdValue: "",
            selectedJournalId: "",
            prefixOperator: "",
            selectedJournalTitle: "",
            selectedRiskFactorTitle: "",
            riskRules: {},
            selectedMedicationTitle: "",
            selectedMedicationId: "",
        };
    }

    componentDidMount() {
        this.fetchRiskRules();
    }

    handleModalClose = () => {
        this.setState({
            showModal: false, loadingJournals: false, loadingRiskFactors: false,
            journals: [], riskFactors: [], thresholdValue: "", selectedComparison: "",
            selectedRuleType: "1", selectedJournalId: "", selectedRiskFactorId: '',
            prefixOperator: ""
        });
    }

    handleModalShow = (type, item) => {
        this.setState((prevState) => ({
            prefixOperator: type === "OR" ? "OR" : type === "AND" ? "AND" : prevState.prefixOperator,
            parentRuleId: item ? item.id : null,
            showModal: true,
        }));
    };


    goBackAdmissionsPage = () => {
        this.props.history.push({
            pathname: "/projectmgmt/patient-admission",
        });
    }

    handleDropdownChange = (event) => {
        var thisController = this;
        this.setState({
            selectedRuleType: event.target.value, journals: [], loadingJournals: true, loadingRiskFactors: false, riskFactors: [], selectedJournalId: "",
            selectedJournalTitle: "", selectedRiskFactorId: "", selectedRiskFactor: "", selectedMedicationId: "", selectedMedicationTitle: ""
        },
            () => {
                if (thisController.state.selectedRuleType === "JOURNAL_ENTRY_VALUE" || thisController.state.selectedRuleType === "NO_JOURNAL_ENTRY") {
                    $.ajax({
                        url: "/my-jeeva-api/patient-journal",
                        type: 'GET',
                        data: {
                            admissionId: thisController.state.admissionId,
                        },
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("access_token"),
                        },
                        success: function (res) {
                            if (res.success == true) {
                                thisController.state.journals = res.result;
                                // thisController.state.selectedJournalId = res.result[0].id
                                thisController.state.loadingJournals = false;
                                // var selectedJournal = res.result.find(journal => res.result[0].id);
                                // var selectedJournalTitle = selectedJournal ? selectedJournal.title : '';
                                // thisController.state.selectedJournalTitle = selectedJournalTitle;
                                thisController.setState(thisController.state);
                                // if (thisController.state.selectedJournalId) {
                                //     thisController.fetchJournalRiskFactors();
                                // }
                            } else {
                                thisController.state.loadingJournals = false;
                                thisController.setState(thisController.state);
                            }
                        },
                        error: function (xhr, status, error) {

                        }
                    });
                } else if (thisController.state.selectedRuleType === "NO_MEDICATION_ADHERENCE") {
                    $.ajax({
                        url: "/my-jeeva-api/get-patient-medications",
                        type: 'GET',
                        data: {
                            patientAdmissionId: thisController.state.admissionId,
                        },
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("access_token"),
                        },
                        success: function (res) {
                            if (res.success == true) {
                                thisController.state.medications = res.result;
                                // thisController.state.loadingJournals = false;    
                                thisController.setState(thisController.state);

                            } else {
                                // thisController.state.loadingJournals = false;
                                thisController.setState(thisController.state);
                            }
                        },
                        error: function (xhr, status, error) {

                        }
                    });
                }

            });
    }

    handleJournalDropdownChange = (event) => {
        var thisController = this;
        thisController.state.selectedJournalId = event.target.value;
        var selectedJournal = this.state.journals.find(journal => journal.id === event.target.value);
        var selectedJournalTitle = selectedJournal ? selectedJournal.title : '';
        thisController.state.selectedJournalTitle = selectedJournalTitle;
        thisController.setState(thisController.state)
        thisController.fetchJournalRiskFactors();
    }
    handleMedicationDropdownChange = (event) => {
        this.state.selectedMedicationId = event.target.value;
        var selectedMedication = this.state.medications.find(medication => medication.id === event.target.value);
        var selectedMedicationTitle = selectedMedication ? selectedMedication.name : '';
        this.state.selectedMedicationTitle = selectedMedicationTitle;
        this.setState(this.state)

    }

    fetchJournalRiskFactors = () => {
        var thisController = this;
        thisController.setState({ loadingRiskFactors: true });

        $.ajax({
            url: "/my-jeeva-api/get-risk-factors",
            type: 'GET',
            data: {
                journalId: thisController.state.selectedJournalId,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.riskFactors = res.result;
                    thisController.state.loadingRiskFactors = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.loadingRiskFactors = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    fetchRiskRules = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/get-risk-rules",
            type: 'GET',
            data: {
                patientAdmissionId: localStorage.getItem("patientAdmissionId"),
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.riskRules = res.result;
                    thisController.setState(thisController.state);
                } else {

                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    handleRiskFactorDropdownChange = (event) => {
        this.state.selectedRiskFactorId = event.target.value;
        var selectedRiskFactor = this.state.riskFactors.find(riskFactor => riskFactor.journalItemId === event.target.value);
        var selectedRiskFactorTitle = selectedRiskFactor ? selectedRiskFactor.name : '';
        this.state.selectedRiskFactorTitle = selectedRiskFactorTitle;
        this.setState(this.state)
    }

    handleComparisonChange = (event) => {
        this.setState({ selectedComparison: event.target.value });
    }

    handleNumberChange = (event) => {
        this.setState({ thresholdValue: event.target.value });
    }

    saveRiskRule = () => {
        var thisController = this;
        var patientAdmissionId = localStorage.getItem("patientAdmissionId");
        var targetId = thisController.state.selectedJournalId;
        var subTargetId = thisController.state.selectedRiskFactorId;
        var type = thisController.state.selectedRuleType;
        var prefixOperator = thisController.state.prefixOperator;
        var targetName = thisController.state.selectedJournalTitle;
        var subTargetName = thisController.state.selectedRiskFactorTitle;
        if (prefixOperator == "") {
            prefixOperator = null;
        } else {
            var parentRuleId = thisController.state.parentRuleId;
        }
        if (parentRuleId == "") {
            parentRuleId = null;
        }

        var threshold = thisController.state.thresholdValue;
        var comparison = thisController.state.selectedComparison;
        if (comparison == "") {
            comparison = null;
        }

        if ((targetId == "" || subTargetId == "" || type == "" || threshold == "") && type !== "COMPLEX_RULE") {
            thisController.notifyEmptyFeilds();
        } else {
            var saveData = {
                patientAdmissionId: patientAdmissionId,
                targetId: targetId,
                subTargetId: subTargetId,
                type: type,
                prefixOperator: prefixOperator,
                threshold: threshold,
                comparison: comparison,
                targetName: targetName,
                subTargetName: subTargetName,
                parentRuleId: parentRuleId,
                riskRuleCategory : "PATIENT_ADMISSION"
            }
            $.ajax({
                url: "/my-jeeva-api/save-risk-rule",
                type: 'POST',
                data: JSON.stringify(saveData),
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.state.showModal = false;
                        thisController.setState(thisController.state);
                        thisController.fetchRiskRules();
                    } else {

                    }
                },
                error: function (xhr, status, error) {

                }
            });

        }

    }

    handleDeleteRule = (ruleId) => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/delete-rule/" + ruleId,
            method: 'DELETE',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.fetchRiskRules();
                } else {
                    console.log("Rule deletion failed");
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    handleEditRule = (ruleId) => {
        var thisController = this;
        var patientAdmissionId = localStorage.getItem("patientAdmissionId");
        var targetId = thisController.state.selectedJournalId;
        var subTargetId = thisController.state.selectedRiskFactorId;
        var type = thisController.state.selectedRuleType;
        var prefixOperator = thisController.state.prefixOperator;
        var targetName = thisController.state.selectedJournalTitle;
        var subTargetName = thisController.state.selectedRiskFactorTitle;
        if (prefixOperator == "") {
            prefixOperator = null;
        } else {
            var parentRuleId = thisController.state.parentRuleId;
        }
        if (parentRuleId == "") {
            parentRuleId = null;
        }

        var threshold = thisController.state.thresholdValue;
        var comparison = thisController.state.selectedComparison;
        if (comparison == "") {
            comparison = null;
        }
        if ((targetId == "" || subTargetId == "" || type == "" || threshold == "") && type !== "COMPLEX_RULE") {
            thisController.notifyEmptyFeilds();
        } else {
            var saveData = {
                id: ruleId,
                patientAdmissionId: patientAdmissionId,
                targetId: targetId,
                subTargetId: subTargetId,
                type: type,
                prefixOperator: prefixOperator,
                threshold: threshold,
                comparison: comparison,
                targetName: targetName,
                subTargetName: subTargetName,
                parentRuleId: parentRuleId
            }
            $.ajax({
                url: "/my-jeeva-api/update-risk-rule",
                type: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.fetchRiskRules();
                    } else {

                    }
                },
                error: function (xhr, status, error) {

                }
            });
        }
    }

    notifyEmptyFeilds() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please fill all the fields before saving
            </b>,
            {
                position: "top-center",
            }
        );
    }

    getComparisonSymbol(comparison) {
        switch (comparison) {
            case 'GREATER_THAN':
                return '>';
            case 'LESS_THAN':
                return '<';
            case 'EQUALS_TO':
                return '=';
            case 'GREATER_THAN_OR_EQUALS_TO':
                return '≥';
            case 'LESS_THAN_OR_EQUALS_TO':
                return '≤';
            default:
                return '';
        }
    }


    getRuleString(rule) {
        var comparisonSymbol = this.getComparisonSymbol(rule.comparison);
        return `(${rule.targetName}-->${rule.subTargetName})${comparisonSymbol}${rule.threshold}`;
    }


    render() {
        const { riskRules } = this.state;
        console.log("riskRules", riskRules);
        const riskRulesArray = Object.values(riskRules);
        console.log("riskRulesArray", riskRulesArray);
        return (
            <div>
                <link rel="stylesheet" href="assets/css/riskRule.css" />
                <ToastContainer className="Toast-at-center" />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <img
                        className="img-responsive"
                        src="./assets/images/arrow.svg"
                        onClick={this.goBackAdmissionsPage}
                        style={{ cursor: "pointer" }}
                    />
                    <h6 className="nav-item" style={{ color: "#282a65", marginTop: "10px", fontSize: "15px" }}>
                        Configure Risk Rule for {localStorage.getItem("patientName")}
                    </h6>
                    <button type="button" className='btn2 table-action-button' style={{marginRight:"2vw", marginTop:"2vh"}}
                    onClick={this.handleModalShow}>Add Risk Rule</button>

                </div>

                {riskRulesArray.map((ruleSet, index) => (
                    <div key={index} className="risk-rule-set">
                        <div className="rule-header">
                            <div>Type</div>
                            <div>Rule String</div>
                            <div>Edit</div>
                            <div>Delete</div>
                        </div>
                        <div className="rule-container">
                            {ruleSet.map((rule, idx) => (
                                <div>
                                    {rule.parentRuleId && <div className="prefix-operator">{rule.prefixOperator}</div>}
                                    {rule.parentRuleId && <hr style={{ marginTop: "1vh" }} />}
                                    <div key={idx} className="rule">
                                        <div>{rule.type}</div>
                                        {/* <div>{rule.targetName}</div>
                                        <div>{rule.subTargetName}</div>
                                        <div>{rule.comparison}</div>
                                        <div>{rule.threshold}</div> */}
                                        <div>{this.getRuleString(rule)} </div>
                                        <div>
                                            <button className="btn2 table-action-button" onClick={() => this.handleEditRule(rule.id)}>Edit</button>
                                        </div>
                                        <div>
                                            <button className="btn2 table-action-button" onClick={() => this.handleDeleteRule(rule.id)}>Delete</button>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>

                        <div className="logic-buttons">
                            <button onClick={() => this.handleModalShow("OR", ruleSet[0])} className="logic-button">OR</button>
                            <button onClick={() => this.handleModalShow("AND", ruleSet[0])} className="logic-button">AND</button>
                        </div>


                    </div>
                ))}


                {/* Modal */}
                {this.state.showModal &&
                    <div className="modal" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ height: "100%" }}>
                                <div className="modal-header" style={{ marginLeft: "10vw", alignItems: "center" }}>
                                    <h5 className="modal-title">Add Risk Rule</h5>
                                    <button type="button" className="close" onClick={this.handleModalClose}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <select value={this.state.selectedRuleType} onChange={this.handleDropdownChange}>
                                        <option value="1">Select Rule Type</option>
                                        <option value="JOURNAL_ENTRY_VALUE">Journal Entry Value</option>
                                        <option value="NO_JOURNAL_ENTRY">No Journal Entry</option>
                                        <option value="NO_MEDICATION_ADHERENCE">No Medication Adherence</option>
                                        <option value="COMPLEX_RULE">Joint Rule</option>
                                    </select>
                                    {/* Journal Dropdown */}
                                    <hr />
                                    {this.state.loadingJournals ? (
                                        <p></p>
                                    ) : (this.state.journals.length > 0 ? (
                                        <select value={this.state.selectedJournalId} onChange={this.handleJournalDropdownChange}>
                                            <option value="">Select Journal</option>
                                            {this.state.journals.map(journal => (
                                                <option key={journal.id} value={journal.id}>{journal.title}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <p></p>
                                    ))}
                                    {this.state.selectedRuleType === "NO_MEDICATION_ADHERENCE" &&
                                        (this.state.medications.length > 0 ? (
                                            <div>
                                                <select value={this.state.selectedMedicationId} onChange={this.handleMedicationDropdownChange}>
                                                    <option value="">Select medication</option>
                                                    {this.state.medications.map(medication => (
                                                        <option key={medication.id} value={medication.id}>{medication.name}</option>
                                                    ))}
                                                </select>
                                                <hr />
                                                {/* Number Input */}
                                                <input type="number"
                                                    value={this.state.thresholdValue}
                                                    placeholder='Enter the value'
                                                    onChange={this.handleNumberChange}
                                                    style={{
                                                        border: "2px solid #777676",
                                                        borderRadius: "10px",
                                                        padding: "10px",
                                                        height: "2.5vh"
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <p>No medications present</p>
                                        ))
                                    }
                                    <hr />
                                    {this.state.loadingRiskFactors ? (
                                        <p>Loading risk factors...</p>
                                    ) : (

                                        this.state.riskFactors.length > 0 ? (
                                            <div>
                                                <select value={this.state.selectedRiskFactorId} onChange={this.handleRiskFactorDropdownChange}>
                                                    <option value="">Select Risk Factor</option>
                                                    {this.state.riskFactors.map(riskFactor => (
                                                        <option key={riskFactor.journalItemId} value={riskFactor.journalItemId}>{riskFactor.name}</option>
                                                    ))}
                                                </select>

                                                <hr />
                                                {/* Comparison Dropdown */}
                                                <select value={this.state.selectedComparison} onChange={this.handleComparisonChange}
                                                    style={{ display: this.state.selectedRuleType === "NO_JOURNAL_ENTRY" || this.state.selectedRuleType === "NO_MEDICATION_ADHERENCE" ? "none" : "block" }}
                                                >
                                                    <option value="">Select Comparison</option>
                                                    <option value="GREATER_THAN">Greater Than</option>
                                                    <option value="LESS_THAN">Less Than</option>
                                                    <option value="EQUALS_TO">Equal To</option>
                                                    <option value="GREATER_THAN_OR_EQUALS_TO">Greater Than or Equals</option>
                                                    <option value="LESS_THAN_OR_EQUALS_TO">Less Than or Equals</option>
                                                </select>
                                                <hr />
                                                {/* Number Input */}
                                                <input type="number"
                                                    value={this.state.thresholdValue}
                                                    placeholder='Enter the value'
                                                    onChange={this.handleNumberChange}
                                                    style={{
                                                        border: "2px solid #777676",
                                                        borderRadius: "10px",
                                                        padding: "10px",
                                                        height: "2.5vh"
                                                    }}
                                                />
                                            </div>
                                        ) : (<p></p>)
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" onClick={this.saveRiskRule}>Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }


}

export default RiskRuleForAdmission;








// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/RiskRuleForAdmission.js